import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import { api, auth } from '@/f1/service';
// import 'vue2-datepicker/index.css';
import Language from './language';


const _i18n_data = {
  username: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};
const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components: { DatePicker, Language },
  data: () => ({ custom, so : default_opt() }),
  computed: {
    i18n_data() { return _i18n_data },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 10%', label: 'No.' },
        // { key: 'group.groupname', sortable: true, label: 'Group' },
        { key: 'permissions', label: 'Permissions' },
        { key: 'is_alive', label: 'Available' },
        { key: 'username', sortable: true, label: 'Username'},
        { key: 'nickname', sortable: true, label: 'Nickname' },
        { key: 'last_visit', label: 'Last Login', sortable: true },
        // { key: 'func', label: 'Detail', sortable: false, thStyle: 'width: 10%'  },
    ]},
    fields_ko() {
      return [
        { key: 'id', thStyle: 'width: 10%', label: 'No.' },
        // { key: 'group.groupname', sortable: true, label: 'Group' },
        { key: 'permissions', label: '권한' },
        { key: 'is_alive', label: '사용여부' },
        { key: 'username', sortable: true, label: '아이디'},
        { key: 'nickname', sortable: true, label: '이름' },
        { key: 'last_visit', label: '마지막 로그인', sortable: true },
        // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
    ]}
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'username,nickname,group.groupname',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { target : 'user', cmd: 'list', limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [{name: 'group_id', value : auth.profile.group_id, op : '='}, {name : 'is_del' , value: false, op : '='}], or: [], sort: [] } }
      // order
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv.replace(/^\s+|\s+$/g,'%');
        console.info(value)
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: `%${value}%`, op: 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          case 'last_visit_sd' : search.body.and.push({name: 'last_visit', value: moment(value).valueOf(), op: '>=' }); break;
          case 'last_visit_ed' : search.body.and.push({name: 'last_visit', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: `%${value}%`, op: value ? 'like' : 'like' }); break;
        }
      }
      console.info(search)
      try { let rs = await api.member.Manager(search); console.info(rs); this.so.totalRows = rs.total; return rs.body; }
      catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) };
    },
    detail(item) { this.$router.push(`/user/${item.id}`); },
  },
  created() { console.log('[vue] user.list', 'created'); },
  destroyed() { console.log('[vue] user.list', 'destroyed'); },
  mounted() { console.log('[vue] user.list', 'mounted'); window.opt = this.so; },
}
